export default __webpack_public_path__ + "9b6484d2aea94633c06caaffb6d4f202.png";